module.exports = __webpack_public_path__ + "76acdf8eabf556dc7e7d8fbb75cf0563.png";